<template>
  <b-form-select
    :options="items"
    v-model="item"
    v-bind="$attrs"
    @input="selected($event)"
  ></b-form-select>
</template>

<script>
export default {
  name: "FSelectField",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    fields: { type: Array, default: () => [] },
    value: { type: String, default: null },
  },
  data: function () {
    return {};
  },
  methods: {
    selected($event) {
      this.$emit("change", $event);
    },
  },
  computed: {
    items() {
      var results = [];

      function pushFields(fields, container_name, prefix) {
        _.each(fields, function (f) {
          results.push({
            text: container_name + f.name,
            value: prefix + f.code,
          });
        });
      }

      pushFields(this.fields, "", "");

      return _.sortBy(results, "text");
    },
  },
  created: function () {
    this.item = this.value;
  },
};
</script>

<style scoped></style>
